import React, { useEffect, useState } from "react";

const DisplaySettings = () => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    // Load theme from localStorage or system preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
      applyTheme(savedTheme);
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const defaultTheme = prefersDark ? "dark" : "light";
      setTheme(defaultTheme);
      applyTheme(defaultTheme);
    }
  }, []);

  const applyTheme = (selectedTheme) => {
    const root = window.document.documentElement;
    if (selectedTheme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  };

  const handleToggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    applyTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  return (
    <div className="space-y-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Display Settings</h2>

      <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded shadow-sm flex justify-between items-center">
        <div>
          <h3 className="font-medium">Theme</h3>
          <p className="text-gray-600 dark:text-gray-300 text-xs">
            Current: <strong className="capitalize">{theme}</strong>. Toggle to switch between light and dark mode.
          </p>
        </div>
        <input
          type="checkbox"
          checked={theme === "dark"}
          onChange={handleToggleTheme}
          className="form-checkbox h-5 w-5"
        />
      </div>
    </div>
  );
};

export default DisplaySettings;
